import { useEffect, useMemo, useState } from 'react';

import { useAtomValue } from 'jotai';

import { pageReadyAtom } from 'src/stores/splash/atom';

const MAX_WAIT_MS = 5000;

const prefersReducedMotion = () =>
  typeof window !== 'undefined' && window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

interface UseReadyResult {
  ready: boolean;
}

/**
 * SplashScreen 종료 조건을 관리하는 훅.
 * pageReadyAtom === true가 되는 즉시 ready: true (최소 노출 시간 없음 — 빠른 네트워크에서
 * 불필요하게 지연되지 않도록 함).
 * prefers-reduced-motion이면 즉시 ready: true.
 * MAX_WAIT_MS(5s) 경과 시 pageReadyAtom과 무관하게 ready: true (웹뷰 에러 화면 등 fallback).
 */
const useReady = (): UseReadyResult => {
  const pageReady = useAtomValue(pageReadyAtom);
  const [maxTimeElapsed, setMaxTimeElapsed] = useState(false);
  const reducedMotion = useMemo(() => prefersReducedMotion(), []);

  useEffect(() => {
    if (reducedMotion) return;
    const timer = window.setTimeout(() => setMaxTimeElapsed(true), MAX_WAIT_MS);
    return () => window.clearTimeout(timer);
  }, [reducedMotion]);

  const ready = reducedMotion || maxTimeElapsed || pageReady;

  return { ready };
};

export default useReady;
